import { createContext, useContext } from "react";

export type Tone = "success" | "error" | "warning" | "info";

export interface Notice {
  title: string;
  description?: string;
  tone?: Tone;
}

export type Notify = (notice: Notice) => void;

export const NotifyContext = createContext<Notify | null>(null);

/** Shows a notice. Outside the app's providers (some tests), does nothing. */
export function useNotify(): Notify {
  return useContext(NotifyContext) ?? (() => undefined);
}
